import * as z from "zod";

const duplicateGroupInfo = z.object({
  groupId: z.string(),
  numericId: z.number().nullable(),
  status: z.string(),
  provider: z.enum(["SHOPIFY", "COMMENTSOLD", "OTHER"]),
  orderNames: z.array(z.string()),
  hasPurchasedLabel: z.boolean(),
  batchId: z.string().nullable(),
  pickSessionId: z.string().nullable(),
});

/** Mirrors SkipReasons in remediate-duplicate-shopify-commentsold-fulfillment-groups.ts. */
const skippedGroup = z.object({
  groupId: z.string(),
  reason: z.enum([
    "not-a-current-duplicate",
    "no-commentsold-survivor",
    "not-open",
    "purchased-label",
    "in-batch",
    "in-pick-session",
    "write-failed",
  ]),
});

const duplicateGroupSet = z.object({
  normalizedOrderName: z.string(),
  shopifyGroups: z.array(duplicateGroupInfo),
  commentsoldGroups: z.array(duplicateGroupInfo),
});

export type DuplicateGroupInfo = z.infer<typeof duplicateGroupInfo>;
export type DuplicateGroupSet = z.infer<typeof duplicateGroupSet>;
export type SkipReason = z.infer<typeof skippedGroup>["reason"];

export const getDuplicateShopifyCommentsoldGroups = {
  name: "getDuplicateShopifyCommentsoldGroups" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ sets: z.array(duplicateGroupSet) }),
  description:
    "List duplicate Shopify/CommentSold fulfillment group sets for a team",
};

export const deleteShopifyDuplicateFulfillmentGroups = {
  name: "deleteShopifyDuplicateFulfillmentGroups" as const,
  input: z.object({ teamId: z.string(), shopifyGroupIds: z.array(z.string()) }),
  output: z.object({
    deletedGroupIds: z.array(z.string()),
    skipped: z.array(skippedGroup),
  }),
  description:
    "Mark duplicate Shopify fulfillment groups as DELETED, leaving the CommentSold group as source of truth",
};
